<template>
  <div class="row therapistsModal">
    <div class="col-6">
      <draggable
        class="list-group"
        tag="ul"
        v-model="therapistsToSort"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            class="list-group-item"
            v-for="element in therapistsToSort"
            :key="element.id"
          >
            <i
              class="glyphicon glyphicon-pushpin"
              aria-hidden="true"
            ></i>
            {{ element.name }}
          </li>
        </transition-group>
      </draggable>
    </div>
    <div class="text-center">
      <el-button type="info" class="mr-3" @click="SET_THERAPISTS_MODAL_VISIBLE(false)">閉じる</el-button>
      <el-button type="primary" @click="submitTherapistsPosition" v-if="permission.can('write', 'coupon')"> 登録 </el-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import permissionService from "../../../services/permission_service";

export default {
  display: "Transitions",
  order: 7,
  components: {
    draggable
  },
  data() {
    return {
      drag: false,
      permission: permissionService
    };
  },
  computed: {
    ...mapGetters(['clinicCouponIsEditPosition']),
    therapistsToSort: {
      get() {
        return this.$store.getters.therapistsToSort
      },
      set(therapists) {
        this.SET_THERAPISTS_TO_SORT(therapists)
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    ...mapMutations('clinic_coupon', ['SET_THERAPISTS_MODAL_VISIBLE', 'SET_THERAPISTS_TO_SORT']),
    ...mapActions('clinic_coupon', ['updateTherapistsPosition']),
    submitTherapistsPosition() {
      this.updateTherapistsPosition()
    }
  },
};
</script>

<style>
.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
</style>
